import { render, staticRenderFns } from "./CashReceiptJournalModal.vue?vue&type=template&id=38653a52&scoped=true&"
import script from "./CashReceiptJournalModal.vue?vue&type=script&lang=js&"
export * from "./CashReceiptJournalModal.vue?vue&type=script&lang=js&"
import style0 from "./CashReceiptJournalModal.vue?vue&type=style&index=0&id=38653a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38653a52",
  null
  
)

export default component.exports